export default __webpack_public_path__ + "static/media/druket-inactive.fb8274ad.svg";